@import "./sellalong-panel.css";

:host {
  padding-top: 64px;
  position: relative;
  top: -34px;
}

.sellalong-panel-heading {
  letter-spacing: 4.4px;
  text-transform: uppercase;
  margin: 40px 0 10px;
  line-height: 1.6em;
  color: var(--sellalong-colour-primary, #000);
  font-size: 22px;
}

.sellalong-panel-help-cta {
  vertical-align: top;
  padding-top: 6px;
}

.sellalong-panel-steps {
  font-family: var(--sellalong-text-font, serif);
  letter-spacing: 0.06em;
  margin: 10px 0;
  color: var(--sellalong-colour-text, #000);
}

.sellalong-panel-steps > li::before {
  font-size: 24px;
  color: var(--sellalong-colour-text, #000);
}

.sellalong-panel-nav svg {
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(54, 54, 54, 0.15);
  color: var(--sellalong-colour-primary, #000);
  height: 40px;
  padding: 5px;
  stroke-width: 1;
  width: 40px;
}

.sellalong-panel-nav-prev,
.sellalong-panel-nav-next {
  align-items: center;
  justify-content: center;
  background-color: #fff;
  display: flex;
  height: 100%;
  position: absolute;
  width: 50px;
  z-index: 100;
}

.sellalong-panel-nav-prev {
  left: 0;
}

.sellalong-panel-nav-next {
  right: 0;
}

.swiper {
  margin: 0 -50px;
  padding: 0 50px;
}

.sellalong-panel-status,
.sellalong-panel-checkout-note {
  font-family: var(--sellalong-text-font, serif);
  letter-spacing: 1px;
}

.sellalong-panel-continue-shopping {
  font-family: var(--sellalong-control-font, serif);
  font-size: 14px;
  letter-spacing: 2.8px;
  margin: 10px 0;
  text-transform: uppercase;
}

.sellalong-panel-nav--hide {
  display: block;
}

.sellalong-panel-nav--hide svg {
  visibility: hidden;
}

.sellalong-panel-login .Form__Row {
  justify-content: center;
}

.sellalong-panel-login .Form__Column:last-child {
  flex-grow: 0;
}

.sellalong-panel-login > p {
  color: var(--sellalong-colour-primary, #000);
  font-family: var(--sellalong-text-font, serif);
  letter-spacing: 1px;
}

.sellalong-panel-login .sellalong-panel-login-email {
  color: var(--sellalong-colour-primary, #000);
  border-color: var(--sellalong-colour-primary, #000);
}

.sellalong-panel-login .sellalong-panel-login-email::placeholder {
  color: var(--sellalong-colour-primary, #000);
}

.sellalong-panel-error > p {
  color: var(--sellalong-colour-primary, #000);
  font-family: var(--sellalong-text-font, serif);
  letter-spacing: 1px;
  margin: 0 0 10px;
  text-align: center;
}

:host(.sellalong-panel-variant-mini) {
  margin: 0 30px 10px;
  padding: 0;
  top: 0;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-heading {
  font-size: 15px;
  letter-spacing: 3.4px;
  margin-top: 10px;
  padding-right: 20px;
  position: relative;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-help-cta {
  padding: 0;
  position: absolute;
  right: 0;
  top: 6px;
  z-index: 1000;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-purchase-list {
  margin: 0 0 10px;
  padding: 0;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-status,
:host(.sellalong-panel-variant-mini) .sellalong-panel-checkout-note {
  font-size: 13px;
  text-align: justify;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-purchase-item {
  width: 340px;
}

:host(.sellalong-panel-variant-mini) .swiper {
  margin: 0 -30px;
  padding: 0 30px;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-nav-prev,
:host(.sellalong-panel-variant-mini) .sellalong-panel-nav-next {
  align-items: flex-start;
  padding-top: 45px;
  width: 30px;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-nav-prev {
  justify-content: left;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-nav-next {
  justify-content: right;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-nav svg {
  height: 28px;
  padding: 0;
  width: 28px;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-nav {
  margin: 0;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-login {
  min-width: 340px;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-login-start-cta {
  font-size: 12px;
  padding: 10px 24px;
}
:host(.sellalong-panel-variant-mini) .sellalong-panel-login-email {
  padding: 8px 14px;
}

:host(.sellalong-panel-variant-mini) .sellalong-panel-status {
  font-size: 12px;
}

@media screen and (max-width: 640px) {
  :host(.sellalong-panel-variant-mini) {
    margin-left: 24px;
    margin-right: 24px;
    max-width: none;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-heading {
    font-size: 13px;
    margin: 10px 0 5px;
    padding: 0;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-help-cta {
    right: -18px;
  }

  :host(.sellalong-panel-variant-mini) .swiper {
    margin: 0 -24px;
    padding: 0 24px;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-nav-prev,
  :host(.sellalong-panel-variant-mini) .sellalong-panel-nav-next {
    width: 24px;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-login {
    min-width: auto;
    left: 0;
    top: 0;
    text-align: center;
    transform: none;
    padding: 0 24px;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-login .Form__Row {
    flex-direction: column;
  }

  :host(.sellalong-panel-variant-mini) .sellalong-panel-login .Form__Column {
    margin: 0 0 5px;
  }
}
